import AuthService from "../../utilities/services/auth.service";
import GroupPurchasesWrapper from "../../components/GroupPurchasesWrapper/GroupPurchasesWrapper";

export default function GroupPurchasesPage() {
  const organization = AuthService.getOrg()[0];

  return (
    <>
      <div className="spacer-sm">
        <GroupPurchasesWrapper organization={organization} />
      </div>
    </>
  );
}
